import { Alert, Button } from '@indipia/ui-core'
import { formatMD } from '@indipia/shared'
import type { OrderVendorRow } from '../../api/orderApi'
import { ORDER_MESSAGE, describeReply } from '../../constants/materialOrder.logic'

// 거래처 회신 결과 — 가능: 입고 확정·양중·경과 / 불가: 사유·가능한 날짜·메모 + 다시 보내기·다른 거래처 고르기.
// 문구 조립은 describeReply(U0)가 한다. 보여줄 값이 없으면(회신 없음·약속 밖 값) 아무것도 그리지 않는다.

interface Props {
  row: OrderVendorRow
  /** 불가 회신일 때만 쓰는 동작(없으면 버튼을 그리지 않음 — 카드 요약 용도) */
  onResendWithAvailDate?: (availDate: string) => void
  onPickOtherVendor?: () => void
  busy?: boolean
}

export function OrderReplyResult({ row, onResendWithAvailDate, onPickOtherVendor, busy = false }: Props) {
  const summary = describeReply(row)
  if (!summary) return null

  if (summary.result === 'ACCEPTED') {
    return (
      <section aria-label={ORDER_MESSAGE.replyTitle} aria-live="polite" className="text-body-sm text-text-primary">
        {summary.text}
      </section>
    )
  }

  const availMd = formatMD(summary.availDate)
  return (
    <section aria-label={ORDER_MESSAGE.replyTitle}>
      <Alert kind="warning" role="status">{summary.text}</Alert>
      {(onResendWithAvailDate || onPickOtherVendor) && (
        <div className="mt-2 flex flex-wrap gap-2">
          {onResendWithAvailDate && summary.availDate && availMd && (
            <Button
              variant="secondary"
              size="sm"
              disabled={busy}
              onClick={() => onResendWithAvailDate(summary.availDate as string)}
            >
              {ORDER_MESSAGE.availDateResend(availMd)}
            </Button>
          )}
          {onPickOtherVendor && (
            <Button variant="secondary" size="sm" disabled={busy} onClick={onPickOtherVendor}>
              {ORDER_MESSAGE.pickOtherVendor}
            </Button>
          )}
        </div>
      )}
    </section>
  )
}
